import { Box } from "@mui/material";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardDivider } from "@/dashboard-design-system/Divider";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

interface OrDividerProps {
  text?: string;
}

export const OrDivider = ({ text }: OrDividerProps) => {
  const { t } = useTranslate();
  const displayText = text || t("common", "or");

  return (
    <Box display="flex" alignItems="center">
      <DashboardDivider sx={{ flexGrow: 1 }} />
      <Box mx={2}>
        <DashboardTypography variant="body2" vibe="text-neutral-moderate">
          {displayText}
        </DashboardTypography>
      </Box>
      <DashboardDivider sx={{ flexGrow: 1 }} />
    </Box>
  );
};
